"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactSlick = _interopRequireDefault(require("react-slick"));
var _lodash = require("lodash");
var _ListingImageV = _interopRequireDefault(require("../elements-image/ListingImageV2"));
var _CarouselArrows = _interopRequireDefault(require("../elements-carousel/CarouselArrows"));
var _reactLazyload = _interopRequireDefault(require("react-lazyload"));
var _placeholderImg = _interopRequireDefault(require("../elements-image/placeholderImg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SpaceCarousel = function SpaceCarousel(_ref) {
  var _ref$spaces = _ref.spaces,
    spaces = _ref$spaces === void 0 ? {} : _ref$spaces,
    isClient = _ref.isClient,
    _ref$urlPrefix = _ref.urlPrefix,
    urlPrefix = _ref$urlPrefix === void 0 ? '' : _ref$urlPrefix;
  var items = (0, _lodash.get)(spaces, 'items', []);
  var ulrPrefixLink = urlPrefix ? "/".concat(urlPrefix) : '';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "spaceSection carouselSections container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12"
  }, /*#__PURE__*/_react.default.createElement("h4", null, spaces.sectionTitle))), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex carousel-row",
    itemProp: "itemListElement",
    itemScope: "",
    itemType: "http://schema.org/ListItem"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "carousel-col"
  }, /*#__PURE__*/_react.default.createElement(_reactSlick.default, {
    slidesToShow: 5,
    slidesToScroll: 1,
    speed: 500,
    infinite: false,
    swipeToSlide: true,
    prevArrow: isClient && /*#__PURE__*/_react.default.createElement(_CarouselArrows.default, null),
    nextArrow: isClient && /*#__PURE__*/_react.default.createElement(_CarouselArrows.default, {
      direction: "right"
    }),
    lazyLoad: true,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 2
      }
    }]
  }, items.map(function () {
    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var i = arguments.length > 1 ? arguments[1] : undefined;
    var listingImageWidths = ['200', '400'];
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "col-xs-12 no-gutter"
    }, /*#__PURE__*/_react.default.createElement("meta", {
      content: item.contentTitle,
      itemProp: "name"
    }), /*#__PURE__*/_react.default.createElement("meta", {
      content: i + 2,
      itemProp: "position"
    }), /*#__PURE__*/_react.default.createElement("meta", {
      content: "".concat(ulrPrefixLink).concat(item.contentLinkUrl),
      itemProp: "url"
    }), /*#__PURE__*/_react.default.createElement("a", {
      href: "".concat(ulrPrefixLink).concat(item.contentLinkUrl)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "carousel"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "caption"
    }, /*#__PURE__*/_react.default.createElement("h4", {
      className: "no-margin capitalize-first-letter"
    }, item.contentTitle)), /*#__PURE__*/_react.default.createElement(_reactLazyload.default, {
      offset: 100,
      placeholder: _placeholderImg.default,
      once: true
    }, /*#__PURE__*/_react.default.createElement(_ListingImageV.default, {
      sizes: '(min-width: 768px) 250px, 50vw',
      imgId: item.contentCloudinaryId,
      alt: item.imageAltText,
      ratio: 880 / 1120,
      widths: listingImageWidths,
      className: "img-rounded"
    })))));
  })))));
};
SpaceCarousel.propTypes = {
  cities: _propTypes.default.object,
  urlPrefix: _propTypes.default.string
};
var _default = exports.default = SpaceCarousel;